module.exports = __webpack_public_path__ + "assets/img/qnbfinansbank@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/qnbfinansbank@2x.png
// module id = 140
// module chunks = 0